import React from 'react';
import classNames from 'classnames';
import fr from 'facet-rest';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TableBody from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableBody';
import { Table } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import EmptyResults from 'Components/ComponentLibrary/Organisms/EmptyResults';
import PropTypes from 'prop-types';
import { useItemListContext } from '../ItemContext';
import NavigateActionPicker from './NavigateActionPicker';
import AdditionalActionsMenu from './AdditionalActionsMenu';
import QueryFormLayout from './QueryFormLayout';
import { metaOverrideSet } from './tableMetaOverrideSet';
import { queryFormMetaOverrideSet } from './queryFormMetaOverrideSet';

const useStyles = buildUseStyles('ItemTable', ((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
    padding: theme.spacing(0, 2),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionsCell: {
    display: 'table-cell',
    whiteSpace: 'nowrap',
  },
})));

const ItemTable = ({ metaOverrideSet: mos }) => {
  const classes = useStyles();
  const { loadModalCollectionByLink } = useModalContext();
  const {
    itemsCollection,
    setItemsCollection,
  } = useItemListContext();
  const { loadRightSidebarCollectionLink } = useRightSidebarContext();

  return (
    <Box className={classNames(classes.root)} test={'facet-plan-page-item-table'}>
      <CollectionQueryForm
        formPadding={'none'}
        formMargin={'none'}
        layout={QueryFormLayout}
        collection={itemsCollection}
        metaOverrideSet={queryFormMetaOverrideSet}
        onSubmit={(searchResultCollection) => {
          setItemsCollection(searchResultCollection);
        }}
      />
      <Table.Table>
        <Table.HeadColumnHeaderSet>
          {itemsCollection.meta().template().list().map((field) => {
            return (
              <Table.HeadColumnHeaderCell
                key={field.attr('name')}
                variant={'head'}
                value={field.attr('prompt')}
              />
            );
          })}
          <Table.HeadColumnHeaderCell
            variant={'head'}
            value={''}
          />
        </Table.HeadColumnHeaderSet>
        <TableBody>
          {itemsCollection.resources().list().map((itemResource) => {
            let onClick = null;
            const detailsRelationship = itemResource.relationship(fr.relationships.details.name);

            if (detailsRelationship && detailsRelationship.meta('relationshipType') === 'linkModal') {
              onClick = () => {
                loadModalCollectionByLink(detailsRelationship.link('related').url());
              };
            } else if (detailsRelationship) {
              onClick = () => {
                loadRightSidebarCollectionLink(detailsRelationship.link('related'));
              };
            }

            return (
              <Table.BodyRow
                key={itemResource.id()}
                onClick={onClick}
              >
                {itemResource.meta().template().list().map((field) => {
                  return (
                    <MetaControl
                      key={field.attr('name')}
                      resource={itemResource}
                      attrName={field.attr('name')}
                      metaOverrideSet={mos || metaOverrideSet}
                    />
                  );
                })}
                <td className={classes.actionsCell}>
                  <NavigateActionPicker resource={itemResource} />
                  <AdditionalActionsMenu resource={itemResource} />
                </td>
              </Table.BodyRow>
            );
          })}
        </TableBody>
      </Table.Table>
      {itemsCollection.resources().empty() ? <EmptyResults /> : null}
    </Box>
  );
};

ItemTable.propTypes = {
  metaOverrideSet: PropTypes.object,
};

ItemTable.defaultProps = {
  metaOverrideSet: null,
};

export default ItemTable;
